import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  audio_ads: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedAudioAd: null,
};

/* ================== THUNKS ================== */

export const fetchAudioAds = createAsyncThunk(
  'audio-ads/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/api/admin/audio-ads', {
          params: { fetchType, page, limit, search }
        });
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createAudioAd = createAsyncThunk(
  'audio-ads/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/audio-ads', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const fetchAudioAdById = createAsyncThunk(
  'audio-ads/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/audio-ads/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateAudioAd = createAsyncThunk(
  'audio-ads/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/audio-ads/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);

export const deleteAudioAd = createAsyncThunk(
  'audio-ads/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/api/admin/audio-ads/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const toggleAudioAdStatus = createAsyncThunk(
  'audio-ads/toggle-status',
  async ({id}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/api/admin/audio-ads/${id}/toggle-status`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);


/* ================== SLICE ================== */

const audioAdSlice = createSlice({
  name: 'audio-ads',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchAudioAds.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchAudioAds.fulfilled, (state, action) => {
            const { data, pagination } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.audio_ads = data;
        })
        .addCase(fetchAudioAds.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(fetchAudioAdById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedAudioAd = action.payload;
        })
        .addCase(fetchAudioAdById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        /* UPDATE */
        .addCase(updateAudioAd.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updateAudioAd.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(toggleAudioAdStatus.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload?.data;

            if (updated) {
                state.audio_ads = state.audio_ads.map((c) =>
                    c.id === updated.id ? updated : c
                );
                state.selectedAudioAd = updated;
            }
        })       
        /* DELETE */
        .addCase(deleteAudioAd.fulfilled, (state, action) => {
          state.audio_ads = state.audio_ads.filter((p) => p._id !== action.payload);
        });
  }
});

export default audioAdSlice.reducer;